// This icon file is generated automatically.
var PFileZipOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.63 5.13h1v1h-1v-1zm0 2.96v2.5h2V8.1h-1v-.96h-1v.96zm1.25.75v1h-.5v-1h.5zm-.25-4.71h1v1h-1v-1zm-1-1h1v1h-1v-1zm1 3h1v1h-1v-1zm0-4h1v1h-1v-1zm7.72 1.38L9 .15A.5.5 0 008.64 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V3.86a.5.5 0 00-.15-.35zm-1 .58H8.4V1.15l2.94 2.94zm.03 8.79H2.62V1.12h1v1h1v-1h2.72V4.5c0 .36.3.66.66.66h3.38v7.71z", "fill-rule": "nonzero" } }] }, "name": "p-file-zip", "theme": "outlined" };
export default PFileZipOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFileZipOutlined.js
// module id = 3415
// module chunks = 0